module.exports = __webpack_public_path__ + "img/airplane-blue-top.7001ab56.svg";